<template>
  <div
    :data-balloon="displayName"
    data-balloon-pos="right"
    class="avatar"
    :data-test="`producer-avatar-${displayName}`"
  >
    <img
      :src="profileImageUrl"
      :alt="`Profile image of ${displayName}`"
      @error="$event.target.src=defaultAvatar"
    />
  </div>
</template>

<script>

export default {
  name: 'TgbAvatar',
  props: {
    displayName: String,
    profileImageUrl: String,
    borderColor: String,
    defaultAvatar: {
      type: String,
      default: './producer/assets/img/profile_placeholder.png',
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  cursor: auto;

  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid;
  }

  & + .avatar {
    margin-left: -4px;
  }
}
</style>
